export default __webpack_public_path__ + "static/article-welcome-to-living-digitally-fc9b6034fb5598751bafb10d2a4964b6.jpg";